import React from "react";
import { Link } from "react-router-dom";

const FULL_LOGO = "https://customer-assets.emergentagent.com/job_senior-bed-finder/artifacts/6o84kwdd_4.png";

export function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="bg-[#1A365D] text-white mt-16" data-testid="site-footer">
      <div className="max-w-[1600px] mx-auto px-4 md:px-8 py-12">
        <div className="grid md:grid-cols-[320px_1fr] gap-10">
          <div>
            <Link to="/" className="inline-block" data-testid="footer-logo">
              <img src={FULL_LOGO} alt="CareBed" className="h-14 w-56 object-cover object-center" />
            </Link>
            <p className="text-white/60 text-sm mt-4 max-w-xs">Helping families and hospital discharge planners find open senior-care beds across Colorado.</p>
          </div>

          <div className="space-y-5">
            <div>
              <h4 className="text-sm font-semibold uppercase tracking-wide text-white/80 mb-2">Important disclaimer</h4>
              <p className="text-white/60 text-xs leading-relaxed" data-testid="footer-disclaimer">
                CareBed is an informational <b>directory only</b>. We are not a healthcare provider, placement or referral
                agency, or agent of any facility. Facility listings, bed availability, pricing, licensing, and other
                details are supplied by third parties and public data and may not be accurate, complete, or current.
                CareBed does <b>not</b> endorse, recommend, guarantee, or take responsibility for the care, services,
                conduct, safety, or responses (or lack of response) of any facility, and is not a party to and not liable
                for any communications, arrangements, or transactions between families and facilities. Nothing here is
                medical, legal, or financial advice. Families and discharge planners should independently verify all
                information — including current licensing and availability — and tour and vet any facility before making
                a placement decision.
              </p>
            </div>
            <div className="flex flex-wrap items-center gap-x-6 gap-y-2 text-sm">
              <Link to="/for-facilities" className="text-white/80 hover:text-white transition-colors" data-testid="footer-for-facilities">For Facilities</Link>
              <Link to="/about" className="text-white/80 hover:text-white transition-colors" data-testid="footer-about">About & Contact</Link>
              <Link to="/blog" className="text-white/80 hover:text-white transition-colors" data-testid="footer-blog">Blog</Link>
              <Link to="/privacy" className="text-white/80 hover:text-white transition-colors" data-testid="footer-privacy">Privacy Policy</Link>
              <Link to="/sms-terms" className="text-white/80 hover:text-white transition-colors" data-testid="footer-sms">SMS Terms</Link>
            </div>
          </div>
        </div>

        <div className="border-t border-white/10 mt-10 pt-6 text-xs text-white/70">
          © {year} CareBed. All rights reserved. CareBed is a directory service and is not affiliated with, and does not represent, any listed facility.
        </div>
      </div>
    </footer>
  );
}
